<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

import { defineComponent, ref } from 'vue';

const NOVSearch = defineComponent({
  setup() {
    const searchQuery = ref("");
    const searchResults = ref([]);
    const pagination = ref({
      per_page: 10,
      total: 11,
      page: 1
    })
    const title = ref("Search NOV");
    const items = ref([
      {
          text: "Home",
          href: "/"
        },
         {
          text: "NOV",
        },
        {
          text: "Search NOV",
          active: true,
        }
    ])
    const isLoading = ref(false)

    const query = ref({
        search: ''        
    })

    return {
      searchQuery,
      searchResults,
      title, 
      items, 
      pagination, 
      query,
      isLoading,
    };
  },
  page: {
    title: "NOV - Search NOV",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader
  }
});

export default NOVSearch;
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex mb-4 justify-content-between">
      <div>
        <h1 class="fs-4 text">Search NOV</h1>
        <small>You must input at least 1 to 3 inputs to search</small>
      </div>
    </div>

    <div class="row">
      <div class="col md-12">
        <div class="card p-2">
          <div class="card-body">
            <form class="row g-3">
              <div class="col-md-3">
                <label for="plateNo" class="form-label">Plate No.</label>
                <input type="search" class="form-control" id="plateNo" value="">
                <div class="text-muted">ex. ABC123 / ABC1234 / AB123456</div>
              </div>
              <div class="col-md-3">
                <label for="novId" class="form-label">NOV ID</label>
                <input type="search" class="form-control" id="novId" value="">
                <div class="text-muted">ex. 12345678AB12345</div>
              </div>
              <div class="col-md-3">
                <label for="mvFileNo" class="form-label">MV File No.</label>
                <input type="search" class="form-control" id="mvFileNo">
                <div class="text-muted">ex. 130012345678901</div>
              </div>
              <div class="col-auto d-flex justify-content-center">
                <button class="btn btn-info waves-effect waves-light align-self-center mr-2" type="submit">
                  <i class="bx bx-search-alt-2 label-icon align-middle fs-16 me-2"></i>
                  Search
                </button>
                 <button class="btn btn-danger waves-effect waves-light align-self-center" type="reset">
                  <i class="mdi mdi-pen-off label-icon align-middle fs-13 me-2"></i>
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-header align-items-center d-flex">
            <div class="flex-grow-1 oveflow-hidden">
              <h4 class="text-muted text-truncates mb-0">
                Search Result
              </h4>
          </div>
          <div class="flex-shrink-0 ms-2">
            <ul class="nav justify-content-end nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#nov" role="tab" aria-selected="true"> NOV </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#media" role="tab" aria-selected="false"> Medias </a>
              </li>
            </ul>
          </div>
          </div><div class="card-body">
            <!-- Tab panes -->
            <div class="tab-content text-muted">
              <div class="tab-pane active" id="nov" role="tabpanel">
                <h1>NOV Coming Soon</h1>
              </div>
              <div class="tab-pane" id="media" role="tabpanel">
                <h1>Media Coming Soon</h1>
              </div>
            </div>
          </div><!-- end card-body -->
        </div>
      </div>
    </div>
  </Layout>
</template>